/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Visa/view.blocks to change it.
import CreditCardVisa from 'DesignSystem/Svgs/CreditCardVisa/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Visa({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods/Method/Details/Card/CardBrand/Visa"
  
}) {
  return (<React.Fragment
>
<CreditCardVisa
  viewPath={`${viewPath}/CreditCardVisa`}
 width={35}
 marginTop="auto"
 marginBottom="auto"
/>
{children}
</React.Fragment>)
}